// Utilities for displaying crawler/job configuration consistently across views

import { formatDistanceToNow } from 'date-fns';
import { getOutputFormat } from './crawlerFormUtils';

export const formatLastRun = (
  date: string | null | undefined,
  options?: { fallback?: string; includeSeconds?: boolean },
): string => {
  const { fallback = 'Never', includeSeconds = true } = options ?? {};
  if (!date) return fallback;
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return fallback;
  return formatDistanceToNow(parsed, { addSuffix: true, includeSeconds });
};

export const formatDeviceType = (device?: string) => {
  if (!device) return 'Desktop';
  const normalized = String(device).toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

export const pickOutputFormat = (
  crawlerApiParams?: any,
  jobApiParams?: any,
  jobOutput?: string
): string => {
  if (crawlerApiParams) return getOutputFormat(crawlerApiParams);
  if (jobApiParams) return getOutputFormat(jobApiParams);
  return (jobOutput || 'JSON').toUpperCase();
};

export const pickDeviceType = (
  crawlerApiParams?: any,
  jobApiParams?: any,
  jobDevice?: string
): string => {
  const raw =
    crawlerApiParams?.device_type ||
    crawlerApiParams?.deviceType ||
    jobApiParams?.device_type ||
    jobApiParams?.deviceType ||
    jobDevice;
  return formatDeviceType(raw);
};

export const pickRetry404 = (
  crawlerApiParams?: any,
  jobApiParams?: any,
  jobRetry?: boolean
): boolean => {
  if (crawlerApiParams && 'retry_404' in crawlerApiParams) return Boolean(crawlerApiParams.retry_404);
  if (crawlerApiParams && 'retry404' in crawlerApiParams) return Boolean(crawlerApiParams.retry404);
  if (jobApiParams && 'retry_404' in jobApiParams) return Boolean(jobApiParams.retry_404);
  if (jobApiParams && 'retry404' in jobApiParams) return Boolean(jobApiParams.retry404);
  return Boolean(jobRetry);
};

export const pickAutoparse = (
  crawlerApiParams?: any,
  jobApiParams?: any,
  jobAutoparse?: boolean
): boolean | undefined => {
  if (crawlerApiParams && 'autoparse' in crawlerApiParams) return crawlerApiParams.autoparse;
  if (jobApiParams && 'autoparse' in jobApiParams) return jobApiParams.autoparse;
  return jobAutoparse;
};

